import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["contactsContainer", "contactTemplate"];

  connect() {
    console.log('Vendor Contacts controller connected');
  }

  addContact() {
    const template = this.contactTemplateTarget.innerHTML;
    const newId = new Date().getTime();
    const newContact = document.createElement('div');
    newContact.innerHTML = template.replace(/_NEW_ID_/g, newId);
    this.contactsContainerTarget.appendChild(newContact);
  }

  removeContact(event) {
    event.currentTarget.closest('[data-contact-id]').remove();
  }
}
